import { render, staticRenderFns } from "./tord_settle_list.vue?vue&type=template&id=c27c06d8&scoped=true&"
import script from "./tord_settle_list.vue?vue&type=script&lang=js&"
export * from "./tord_settle_list.vue?vue&type=script&lang=js&"
import style0 from "./tord_settle_list.vue?vue&type=style&index=0&id=c27c06d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27c06d8",
  null
  
)

export default component.exports